<script setup lang="ts">
import { ref } from "vue";

import BaseModal from "@/components/BaseModal.vue";
import type { MapInfo } from "@/types";

const { mapInfo } = defineProps<{
  mapInfo: MapInfo;
}>();

const emit = defineEmits<{
  didHide: [];
}>();

const isOpen = ref(true);
</script>

<template>
  <BaseModal v-model="isOpen" title="Information" size="md" @did-hide="emit('didHide')">
    <div class="map-info-content">
      <p style="white-space: pre-wrap">{{ mapInfo.content }}</p>
    </div>
  </BaseModal>
</template>
